var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var DateFormat = require('../../../components/dateFormat.jsx');
var Tags = require('./tags.jsx');
var Targets = require('./targets.jsx');

var MessageListItem = createReactClass({
    mixins: [PureRenderMixin],

    handleClick: function(){
        this.props.setMessage(this.props.message);
    },

    render: function () {
        return (
            <li className="message-list-item">
                <h2>
                    <Link to={'/admin/message-center/' + this.props.message._id} onClick={this.handleClick}>
                        {this.props.message.subject.text}
                    </Link>
                </h2>
                <p className="date"><DateFormat date={this.props.message.updatedAt} format="MMM DD YYYY" /></p>
                <Tags tagIDs={this.props.message.tags} tags={this.props.tags} />
                <p className="text">{this.props.message.text}</p>
                <Targets targetIDs={this.props.message.meta.target} targets={this.props.targets} />
            </li>
        );
    }
});

module.exports = MessageListItem;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/messageListItem.jsx